import { REQUIRED_FIELD_MESSAGE } from "constants/errorMessages";
import every from "lodash/every";
import isEmpty from "lodash/isEmpty";
import * as yup from "yup";

import { AttributeTypes } from "../../constants/enums";
import { categoryImage, categoryName } from "./categoryValidation";

export const SubChildCategorySchema = yup.object({
  name: categoryName("Sub-sub-category name"),
  image: categoryImage(),
  attributes: yup
    .array()
    .of(
      yup.object().shape({
        name: categoryName("Title"),
        isMain: yup.boolean().required(),
        type: yup
          .string<AttributeTypes>()
          .required(REQUIRED_FIELD_MESSAGE(`Attribute type`)),
        values: yup
          .array()
          .required()
          .when("type", {
            is: (type: AttributeTypes) =>
              [AttributeTypes.Required, AttributeTypes.Additional].includes(
                type
              ),
            then: () =>
              yup
                .array()
                .test(
                  "min-values",
                  "You must select minimum one value",
                  (values) => {
                    return !isEmpty(values) && !every(values, { delete: true });
                  }
                )
          })
      })
    )
    .required()
});
